export function classNames(...classNames: Array<string | boolean | undefined>) {
	return classNames.filter(className => !!className).join(" ");
}
